<template>
  <v-container>
    <v-row>
      <v-col>
        <v-sheet height="64">
          <v-toolbar flat>
            <v-progress-linear
              :active="calendarIsLoading"
              :indeterminate="calendarIsLoading"
              absolute
              bottom
            ></v-progress-linear>

            <v-btn
              outlined
              class="mr-4"
              color="grey darken-2"
              @click="setToday"
            >
              Dnes
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="prev">
              <v-icon small>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="next">
              <v-icon small>
                mdi-chevron-right
              </v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn plain class="mr-4" @click="reloadFreeSlotVariants">
              <v-icon small>
                mdi-refresh
              </v-icon>
              Nabídnout jiné varianty
            </v-btn>
          </v-toolbar>
        </v-sheet>

        <v-sheet
          v-if="!calendarIsLoading && eventsFilteredPreselected.length == 0"
        >
          <v-alert border="left" type="warning" colored-border>
            V termínu od do nemáme žádné volné instruktory, kteří by splňovali
            vaše požadavky. Zkuste změnit požadovaný jazyk výuky nebo zvolit
            jiný termín.
          </v-alert>
        </v-sheet>

        <v-tabs @change="tabsChange" v-model="selectedVariant">
          <v-tab v-for="(variant, i) in variants" :key="i">
            <v-badge
              v-if="lastSelectedVariant == variant"
              color="green"
              :content="numberOfSelectedEvents"
            >
              Varianta {{ i + 1 }}
            </v-badge>
            <template v-else> Varianta {{ i + 1 }}</template>
          </v-tab>
        </v-tabs>

        <v-sheet height="465">
          <v-calendar
            ref="calendar"
            locale="cs"
            v-model="focus"
            color="primary"
            first-interval="7"
            interval-count="12"
            type="4day"
            :start="checkInDate"
            :events="eventsFilteredPreselected"
            :event-color="getEventColor"
            @click:event="eventClick"
            @change="fetchEvents"
          >
            <template v-slot:event="{ event }" color="success">
              <div
                v-if="!event.engaged"
                style="width: 100%; height: 100%; font-size: 1rem; text-align:center; vertical-align:center; background-color:#d9ed92; color: black"
              >
                <v-icon color="black">mdi-plus</v-icon>
              </div>
              <div
                v-if="event.engaged"
                style="width: 100%; height: 100%; font-size: 1rem; text-align:center; vertical-align:center;background-color:#80b918; color: black"
              >
                <v-icon color="black">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-calendar>
        </v-sheet>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogVariantSwap" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Změna varianty
        </v-card-title>

        <v-card-text>
          Výukové lekce lze vybírat pouze z jedné nabízené varianty. Výběrem
          výukové lekce z této varianty se zruší ostatní již vybrané výukové
          lekce.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogVariantSwap = false">
            Storno
          </v-btn>
          <v-btn color="primary" text @click="doSwapVariants">
            Změnit variantu
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import APIAdapter from "../store/APIAdapter";
import CoursePrivateUtil from "../libs/CoursePrivateUtil";

export default {
  name: "CoursePrivateCalendar",

  data() {
    return {
      focus: "",
      events: [],
      selectedEvents: new Map(),
      numberOfSelectedEvents: 0,
      eventToBeSelected: null,
      lastSelectedVariant: null,
      variants: [],
      selectedVariant: 0,
      calendarIsLoading: false,
      dialogVariantSwap: false
    };
  },

  mounted() {
    this.$refs.calendar.checkChange();
  },

  props: {
    product: {
      type: Object,
      required: true
    },
    checkInDate: {
      type: String,
      required: true
    },
    languages: {
      type: [],
      required: true
    },
    skillLevelClient: {
      type: String,
      required: true
    },
    numberOfHoursRequired: {
      type: Number,
      required: true
    }
  },

  computed: {
    mobConfig() {
      return this.$store.state.mobConfig;
    },

    // eventsByVariant() {
    //   const selectedsubjectMssId = this.variants[this.selectedVariant];
    // },

    selectedVariantId() {
      console.log("computed - selectedVariantId");
      if (this.variants == null || this.variants.length == 0) {
        return null;
      }

      return this.variants[this.selectedVariant];
    },

    eventsFiltered() {
      console.log("computed - eventsFiltered");
      if (this.events == null || this.events.length == 0) {
        return [];
      }

      let filteredEvents = this.events.filter(
        e => e.subjectMssId === this.selectedVariantId
      );

      return filteredEvents;
    },

    eventsFilteredPreselected() {
      console.log("computed - eventsFilteredPreselected");

      if (this.eventsFiltered == null || this.eventsFiltered.length == 0) {
        return [];
      }

      let filteredPreselected = [];
      // jiz rezervovane bloky
      for (let i = 0; i < this.eventsFiltered.length; i++) {
        let e = this.eventsFiltered[i];
        if (this.selectedEvents.has(e.hash)) {
          e.engaged = true;
        }
        filteredPreselected.push(e);
      }

      return filteredPreselected;
    },

    candidateSlots() {
      // bloky dle produkty
      const candidateEvents = CoursePrivateUtil.getEventsByProduct(
        this.product,
        this.mobConfig.schoolBookingOffset,
        this.$refs.calendar.lastStart.date,
        this.$refs.calendar.lastEnd.date
      );

      const candidateSlots = CoursePrivateUtil.transformEventsToCandidateSlots(
        candidateEvents
      );

      console.log("candidateEvents");
      console.log(candidateEvents);

      console.log("candidateSlots");
      console.log(candidateSlots);

      return candidateSlots;
    }
  },

  methods: {
    eventClick(payload) {
      console.log("eventClick:: ");
      console.log(payload.event);
      console.log(this.selectedVariantId);

      // zkontrolovat, jesli kliknul na lekci z jine varianty
      // pripadne upozornit na zmenu
      // provest reset
      let variantIdOfSelectedEvents = this.selectedVariantId; // default
      if (this.selectedEvents != null && this.selectedEvents.size > 0) {
        variantIdOfSelectedEvents = this.selectedEvents.values().next().value
          .subjectMssId;
        console.log("prebiram IDcko z jiz oznaceneho event");
      }
      console.log(variantIdOfSelectedEvents);
      if (payload.event.subjectMssId != variantIdOfSelectedEvents) {
        console.log("---> zmena varianty");
        // ulozeni do docasne promenne
        this.eventToBeSelected = payload.event;
        // upozornit na zmenu
        this.dialogVariantSwap = true;
      } else {
        console.log("---> nic se nemeni");
        this.selectEvent(payload.event);
      }
    },

    doSwapVariants() {
      this.resetSelectedEvents();
      this.selectEvent(this.eventToBeSelected);
      this.dialogVariantSwap = false;
    },

    resetSelectedEvents() {
      this.selectedEvents = new Map();
      this.numberOfSelectedEvents = 0;
      for (let i = 0; i < this.events.length; i++) {
        this.events[i].engaged = false;
      }
    },

    selectEvent(event) {
      event.engaged = !event.engaged;

      if (this.selectedEvents.has(event.hash)) {
        event.engaged = false;
        this.selectedEvents.delete(event.hash);
        this.numberOfSelectedEvents--;
      } else {
        event.engaged = true;
        this.selectedEvents.set(event.hash, event);
        this.numberOfSelectedEvents++;
      }

      this.lastSelectedVariant = event.subjectMssId;

      this.$emit("change:lessons", Array.from(this.selectedEvents.values()));
    },

    getEventColor(event) {
      return event.color;
    },

    setToday() {
      this.focus = "";
    },

    prev() {
      this.$refs.calendar.prev();
    },

    next() {
      console.log(this.$refs.calendar);
      this.$refs.calendar.next();
    },

    async getVariants(candidateSlots, dateStart, dateEnd) {
      this.calendarIsLoading = true;
      try {
        if (
          candidateSlots == null ||
          candidateSlots.length == 0 ||
          this.languages == null ||
          this.languages.length == 0
        ) {
          this.calendarIsLoading = false;
          return [];
        }

        let schoolListVariants = await APIAdapter.schoolListVariants(
          this.mobConfig.appInstance,
          this.mobConfig.mobVersion,
          dateStart,
          dateEnd,
          10730, // locationMssId // prevzit z kontextu
          this.product.skill.mssId, //skillMssId, // prevzit z kontextu
          this.languages, // kody jazyku
          1, //
          1, //
          candidateSlots
        );
        console.log("schoolListVariants");
        console.log(schoolListVariants);

        this.calendarIsLoading = false;

        return schoolListVariants;
      } catch (e) {
        console.error(e);
      }
      this.calendarIsLoading = false;
    },

    async getAvailability(
      candidateSlots,
      dateStart,
      dateEnd,
      freeSlotVariants
    ) {
      let schoolListFreeSlots = await APIAdapter.schoolListFreeSlots(
        this.mobConfig.appInstance,
        this.mobConfig.mobVersion,
        dateStart,
        dateEnd,
        freeSlotVariants,
        candidateSlots
      );
      console.log("schoolListFreeSlots");
      console.log(schoolListFreeSlots);
      return schoolListFreeSlots;
    },

    // vygeneruje casove bloky, ktere si lze rezervovat
    async fetchEvents() {
      console.log("fetchEvents");
      this.calendarIsLoading = true;

      if (this.variants == null || this.variants.length == 0) {
        console.log("- jdu nacitat varianty");
        this.variants = await this.getVariants(
          this.candidateSlots,
          this.$refs.calendar.lastStart.date,
          this.$refs.calendar.lastEnd.date
        );
        console.log("- jdu nacitat varianty -- hotovo");
      }

      if (this.variants.length == 0) {
        console.log("- varianty jsou length 0, konec, sluz");
        this.calendarIsLoading = false;
        return [];
      }

      // odecist nedostupne bloky podle dostupnosti
      try {
        const freeSlots = await this.getAvailability(
          this.candidateSlots,
          this.$refs.calendar.lastStart.date,
          this.$refs.calendar.lastEnd.date,
          this.variants
        );
        console.log("freeSlots========");
        console.log(freeSlots);

        let events = CoursePrivateUtil.transformFreeSlotsToEvents(freeSlots);

        console.log("events========");
        console.log(events);

        // propsani do reaktivni promenne
        this.events = events;
      } catch (e) {
        console.error(e);
      }

      this.calendarIsLoading = false;
    },

    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    async reloadFreeSlotVariants() {
      this.events = [];
      this.variants = [];
      this.selectedEvents = new Map();
      this.lastSelectedVariant = null;
      this.numberOfSelectedEvents = 0;
      this.$emit("change:lessons", Array.from(this.selectedEvents.values()));

      this.variants = await this.getVariants(
        this.candidateSlots,
        this.$refs.calendar.lastStart.date,
        this.$refs.calendar.lastEnd.date
      );

      this.selectedVariant = 0;

      this.fetchEvents();
    },

    // calendarChange(e) {
    //   console.log("calendarChange");
    //   console.log("- variants: ");
    //   console.log(this.variants);
    //   if (this.variants != null || this.variants.length == 0) {
    //     return;
    //   }

    //   this.fetchEvents();
    // },

    tabsChange(index) {
      console.log("tabsChange");
      console.log(index);
      // this.selectedEvents = new Map();
      // this.$emit("change:lessons", Array.from(this.selectedEvents.values()));

      // const selectedsubjectMssId = this.variants[this.selectedVariant];

      // let filteredEvents = this.events.filter(
      //   e => e.subjectMssId === selectedsubjectMssId
      // );

      // for (let i = 0; i < filteredEvents.length; i++) {
      //   let e = filteredEvents[i];
      //   if (this.selectedEvents.has(e.hash)) {
      //     e.engaged = true;
      //   } else {
      //     e.engaged = false;
      //   }
      // }
    }
  }
};
</script>
